module.exports = __webpack_public_path__ + "static/media/ic_checkbox_off.294a0bff.svg";